import NavBar from "../../Components/NavBar";
import HeroSection from "./HeroSection";
import { Box } from "@mui/material";
import ZutoPayFeatures from "./ZutoPayFeatures";
import PaymentSection from "./PaymentSection";
import IntegrateZutopay from "./IntegrateZutopay";
import Expandingimpact from "./Expandingimpact";
import ExtendedServices from "./ExtendedServices";
import YourPayment from "./YourPayment";
import FromStartup from "./FromStartup";
import SimplePrising from "./SimplePrising";
import Phone from "./Phone";
import Faq from "./Faq";
import Footer from "../../Components/Footer";
const Home = () => {
    return (
        <Box sx={{ backgroundColor: "#f8f8f8" }}>
            <NavBar textColor="#ffffff" logoTextColor="#ffffff" />
            <HeroSection />
            <ZutoPayFeatures />
            <PaymentSection />
            <IntegrateZutopay />
            <Expandingimpact />
            <ExtendedServices />
            <YourPayment />
            <FromStartup />
            <SimplePrising />
            <Faq />
            <Phone />
            <Footer />
        </Box>
    );
};

export default Home;
